function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#E6E6E6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M11.8927 9.49854L6 12.1775L11.8927 15.6609L17.7866 12.1775L11.8927 9.49854Z",
  fill: "#7850CD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.45,
  d: "M6.00183 12.1778L11.8946 15.6613V9.49892V2.3999L6.00183 12.1778Z",
  fill: "#7850CD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M11.8945 2.3999V9.49892V15.6613L17.7873 12.1778L11.8945 2.3999Z",
  fill: "#7850CD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.45,
  d: "M6 13.2959L11.8927 21.6001V16.7772L6 13.2959Z",
  fill: "#7850CD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M11.8925 16.7772V21.6001L17.7896 13.2959L11.8925 16.7772Z",
  fill: "#7850CD"
});

const SvgEthToken = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEthToken, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eth_token.876913cb.svg";
export { ForwardRef as ReactComponent };